import * as types from './types';

const appliedFilter = newFilter => ({
  type: types.UPDATE_APPLIED_FILTER,
  payload: {
    newFilter
  }
});

export { appliedFilter };
